import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { LayoutDashboard, Languages, BookOpen, LogOut, UserCircle, Globe  } from 'lucide-react';


export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => { logout(); navigate('/login'); };
  const initials = user?.username?.slice(0, 2).toUpperCase() || 'LF';

  return (
    <div className="app-layout">
      <aside className="sidebar">
        <div className="sidebar-logo">LinguaFlow</div>
        <nav>
          <NavLink to="/dashboard" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
            <LayoutDashboard size={16} /> Dashboard
          </NavLink>
          <NavLink to="/translate" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
            <Languages size={16} /> Translate
          </NavLink>
          <NavLink to="/decks" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
            <BookOpen size={16} /> My Decks
          </NavLink>
          <NavLink to="/explore" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
            <Globe size={16} /> Explore
          </NavLink>
          <NavLink to="/profile" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
            <UserCircle size={16} /> Profile
          </NavLink>
        </nav>
        <div className="sidebar-footer">
          <div className="user-chip">
            <div className="avatar">{initials}</div>
            <div>
              <div className="name">{user?.username}</div>
              <div className="streak">🔥 {user?.streak_count || 0} day streak</div>
            </div>
          </div>
          <button className="btn btn-secondary" style={{ width: '100%', fontSize: '0.8rem' }} onClick={handleLogout}>
            <LogOut size={13} /> Sign Out
          </button>
        </div>
      </aside>
      <main className="main-content">{children}</main>
    </div>
  );
}
